(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-images"] && !window.DesignMode) return;
  try {
    
  class MediaAssetsDrawer extends HTMLElement {
    constructor() {
      super();
      this.drawer = this.querySelector('.drawer__inner');
      this.closeButton = this.querySelector('.drawer__close');
      this.overlay = this.querySelector('.cart-drawer__overlay');
      this.mediaGroup = this.closest('.media-images-section').querySelector('.media-group');

      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.overlay.addEventListener('click', this.close.bind(this));
      this.closeButton.addEventListener('click', this.close.bind(this));
      this.mediaGroup.addEventListener('click', this.open.bind(this));
      this.mediaGroup.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.open();
        }
      });
    }

    onKeyUp(event) {
      if (event.code === 'Escape') {
        this.close();
      }
    }

    open() {
      this.setAttribute('open', '');
      this.classList.add('active');
      document.body.classList.add('overflow-hidden');
      trapFocus(this.drawer);
      this.closeButton.focus();
    }

    close() {
      this.removeAttribute('open');
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(this.mediaGroup);
      this.mediaGroup.focus();
    }
  }

  customElements.define('media-assets-drawer', MediaAssetsDrawer);

  function trapFocus(element) {
    const focusableElements = element.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    element.addEventListener('keydown', function(e) {
      const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastFocusableElement) {
          firstFocusableElement.focus();
          e.preventDefault();
        }
      }
    });

    firstFocusableElement.focus();
  }

  function removeTrapFocus(element) {
    element.removeEventListener('keydown', trapFocus);
  }

  function initMediaImagesSections() {
    const mediaImagesSections = document.querySelectorAll('.media-images-section');
    
    if (mediaImagesSections.length > 0) {
      let container = document.querySelector('.media-groups-container.page-width');
      
      if (!container) {
        container = document.createElement('div');
        container.className = 'media-groups-container page-width';
        mediaImagesSections[0].parentNode.insertBefore(container, mediaImagesSections[0]);
      }
      
      mediaImagesSections.forEach(section => {
        if (!section.parentNode.classList.contains('media-groups-container')) {
          container.appendChild(section);
        }

        const mediaGroup = section.querySelector('.media-group');
        if (mediaGroup) {
          mediaGroup.addEventListener('click', function() {
            toggleMediaAssetsDrawer(this);
          });
        }

        const closeButton = section.querySelector('.drawer__close');
        if (closeButton) {
          closeButton.addEventListener('click', function() {
            const drawer = this.closest('media-assets-drawer');
            if (drawer) {
              drawer.close();
            }
          });
        }
      });
    }
  }

  // Initialize on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', initMediaImagesSections);

  // Re-initialize when Shopify's section:load event is triggered
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('media-images-section')) {
      initMediaImagesSections();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
